import React, { FC, forwardRef } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import CheckboxIcon from './CheckboxIcon';
import CheckboxInput from './CheckboxInput';
import CheckboxLabel from './CheckboxLabel';
import { CheckboxProps, StyledBoxProps } from './types';

const StyledBox = styled('div', { shouldForwardProp })<StyledBoxProps>(
  ({ disabled }) =>
    css({
      position: 'relative',
      ...(disabled && {
        [`~ ${CheckboxLabel}`]: {
          opacity: 0.5,
          color: 'checkbox.error.labelColor',
          cursor: 'not-allowed',
        },
      }),
    })
);

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { children, checked, disabled, hasError, type = 'default', sx, ...rest },
    ref
  ) => (
    <StyledBox disabled={disabled}>
      <CheckboxInput
        checked={checked}
        disabled={disabled}
        hasError={hasError}
        sx={sx}
        ref={ref}
        {...rest}
      />
      <CheckboxIcon
        checked={checked}
        disabled={disabled}
        hasError={hasError}
        type={type}
        sx={sx}
      />
    </StyledBox>
  )
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['default', 'circle']),
  sx: PropTypes.object,
};

export default Checkbox;
